module.exports = __webpack_public_path__ + "static/media/circle8.6a133716.svg";